import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { STAGE_MAP } from "@/lib/constants";
import { ScrollText, Loader2 } from "lucide-react";

const OUTCOME_STYLE = {
  APPROVE: "text-success", PASS: "text-success", SIGNED: "text-success",
  ITERATE: "text-warning", PARK: "text-warning", REVIVE: "text-primary",
  REJECT: "text-danger",
};

export default function DecisionLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/decisions").then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6">
      <header className="mb-6">
        <h1 className="font-heading text-4xl font-black tracking-tighter flex items-center gap-3">
          <ScrollText className="w-8 h-8 text-primary" /> Decision Log
        </h1>
        <p className="text-sm text-muted-foreground mt-1">Every gate decision — AI auto-pass, sign-off, and high-stakes council calls — with full accountability.</p>
      </header>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>
      ) : (
        <div className="border border-border rounded-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-card border-b border-border text-left">
                {["Outcome", "Idea", "Stage", "Type", "Reason", "By", "When"].map((h) => (
                  <th key={h} className="p-2.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={`decision-row-${r.id}`} onClick={() => navigate(`/ideas/${r.idea_id}`)}
                  className="border-b border-border hover:bg-white/[0.04] cursor-pointer transition-colors duration-200">
                  <td className={`p-2.5 font-mono text-xs font-semibold ${OUTCOME_STYLE[r.outcome] || "text-muted-foreground"}`}>{r.outcome}</td>
                  <td className="p-2.5 font-medium">{r.idea_title}</td>
                  <td className="p-2.5 text-muted-foreground">{STAGE_MAP[r.stage]?.short || r.stage}</td>
                  <td className="p-2.5 text-muted-foreground font-mono text-xs">{r.type}</td>
                  <td className="p-2.5 text-muted-foreground max-w-xs truncate">{r.reason}</td>
                  <td className="p-2.5 text-muted-foreground">{r.by}</td>
                  <td className="p-2.5 text-muted-foreground font-mono text-xs whitespace-nowrap">{new Date(r.at).toLocaleString()}</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={7} className="p-8 text-center text-muted-foreground">No decisions logged yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
